import React from 'react';
import { useAppDispatch, useAppSelector } from '@hooks/useStore';
import { setIsFinishAccountSignUpModalState } from '@state/files/filesSlice';
import { Trans } from 'react-i18next';
import { selectUserState } from '@state/user/userSlice';
import { Statuses } from '@helpers';

const AccountWarningBox = () => {
  const user = useAppSelector(selectUserState);
  const dispatch = useAppDispatch();
  const getWarningMessages = () => {
    if (user.state === Statuses.Invited) {
      return (
        <Trans
          i18nKey="warning-box.unConfirmed-acc"
          components={{ text: <span style={{ fontWeight: 700, textDecoration: 'underline' }} /> }}
        />
      );
    }
    return '';
  };
  if (user.state !== Statuses.Invited) {
    return <></>;
  }
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      onClick={() => {
        dispatch(setIsFinishAccountSignUpModalState(true));
      }}
      style={{
        display: 'flex',
        padding: '5px',
        borderRadius: '10px',
        backgroundColor: '#ffcc00',
        fontWeight: 'bold'
      }}
    >
      <div style={{ cursor: 'pointer', textAlign: 'center' }}>{getWarningMessages()}</div>
    </div>
  );
};

export default AccountWarningBox;
